import React from 'react';
interface AppRouteProps {
    routeKey: string;
    component: any;
    parentKey?: string;
}
export const AppRoute: React.FC<AppRouteProps> = ({component: Component, routeKey, ...props}) => {
    return <Component {...props} />;
};

export default AppRoute;
